import { render } from "./AddCategory.vue?vue&type=template&id=0702e328&scoped=true&ts=true"
import script from "./AddCategory.vue?vue&type=script&lang=ts"
export * from "./AddCategory.vue?vue&type=script&lang=ts"

import "./AddCategory.vue?vue&type=style&index=0&id=0702e328&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0702e328"]])

export default __exports__